<template>
  <div class="workoutBasicForm">
    <div class="workoutMetaStrip workoutMetaStrip--voice">
      <el-form-item :label="L.displayName" required>
        <el-input v-model="local.display_name" />
      </el-form-item>
      <el-form-item :label="L.gender" required class="workoutFormItem--compact">
        <el-select v-model="local.gender">
          <el-option
            v-for="item in genderOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="L.language" required class="workoutFormItem--compact">
        <el-select v-model="local.language">
          <el-option
            v-for="item in languageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </div>
  </div>
</template>

<script>
import basicFormMixin from './basicFormMixin'
import {
  WORKOUT_FIELD_LABELS,
  WORKOUT_GENDER_OPTIONS,
  WORKOUT_LANGUAGE_OPTIONS,
} from './workoutFormConstants'
import './workoutFormLayout.css'

const EMPTY = () => ({
  display_name: '',
  gender: '',
  language: 'en',
})

export default {
  name: 'WorkoutVoiceBasicForm',
  mixins: [basicFormMixin],
  data() {
    return {
      local: EMPTY(),
      L: WORKOUT_FIELD_LABELS,
      languageOptions: WORKOUT_LANGUAGE_OPTIONS,
      genderOptions: WORKOUT_GENDER_OPTIONS,
    }
  },
  methods: {
    buildExtaPayload() {
      return {
        display_name: this.local.display_name,
        gender: this.local.gender,
        language: this.local.language,
      }
    },
    loadFromExta(exta) {
      const data = exta || {}
      this.local = {
        ...EMPTY(),
        display_name: data.display_name || '',
        gender: data.gender || '',
        language: data.language || 'en',
      }
    },
    reset() {
      this.local = EMPTY()
    },
    validate() {
      if (!String(this.local.display_name || '').trim()) {
        return Promise.reject(`请填写 ${WORKOUT_FIELD_LABELS.displayName}`)
      }
      if (!this.local.gender) {
        return Promise.reject(`请选择 ${WORKOUT_FIELD_LABELS.gender}`)
      }
      if (!this.local.language) {
        return Promise.reject(`请选择 ${WORKOUT_FIELD_LABELS.language}`)
      }
      return Promise.resolve()
    },
    captureSnapshot() {
      return { ...this.local }
    },
  },
}
</script>
